module.exports = __webpack_public_path__ + "img/banner-wbs.d7139456.jpg";